import { isEmpty, lowerCase, startCase } from "lodash";
import { cdnImg } from "../../Utils/cdnImage";
import moment from "moment";
import React from "react";
import HomeSelection from "./HomeSelection";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import LiveMatchTracker from "../Score/ScoreBoard";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import ListParlay from "./ListParlay";
import { formatNumber, formatWithCommas } from "../../Utils/Toast";
import { isMobile } from "react-device-detect";
import { getDomain } from "../../Utils/constants";
import ThemeContext from "../../context/ThemeContext";

const ListingSportComp = ({
  heading,
  data,
  odds,
  type,
  handle,
  active,
  showAll,
  showScore,
  handleScore,
  activeFav,
  addToFavioute,
}) => {
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const blockList = useContextSelector(AuthContext, (ctx) => {
    return ctx.blockList;
  });
  const scoreAll = useContextSelector(AuthContext, (ctx) => {
    return ctx.scoreAll;
  });
  const matchLimit = useContextSelector(AuthContext, (ctx) => {
    return ctx.matchLimit;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const navigate = useNavigate();
  let tabPosition = {
    cricket: "bottom",
    tennis: "top",
    soccer: "bottom",
  };
  const displayScore = ({ object }) => {
    return (
      <iframe
        style={{ width: "100%", height: "141px", position: `relative` }}
        src={object?.scoreCustomUrl}
      />
    );
  };

  const RenderSingle = ({ item, animate }) => {
    return (
      <div
        data-v-089ef46b
        className="s-bg-white dark:s-bg-main-block-dark s-border-b s-border-black-100 dark:s-border-black-900 s-shadow-2sm s-h-full"
      >
        <div
          onClick={() =>
            navigate(`/match-detail/${item?.eventId}/${item?.marketId}`)
          }
          data-v-089ef46b
          className={`${
            isMobile ? "isDefaultMobile" : "isDefaultDesktop"
          } s-event-grid s-grid s-justify-center s-items-center s-gap-10px s-py-7px s-px-10px`}
        >
          <div
            onClick={(e) => {
              if (item?.runners?.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                addToFavioute(
                  item?.eventId,
                  "Match Odds",
                  item?.marketId,
                  item?.eventType,
                );
              }
            }}
            data-v-5460a16b
            data-v-089ef46b
            className="s-fav s-text-black-300 dark:s-opacity-15 s-text-16px s-w-16px"
          >
            <div
              data-v-5460a16b
              className={`s-relative s-icon-star${
                animate ? "-solid s-animate-star-line-box" : ""
              }`}
            >
              <span
                data-v-5460a16b
                className={`s-rating-star-line s-bg-market-star-icon dark:s-bg-market-star-icon ${
                  animate ? "s-animate-star-line" : ""
                }`}
              />
              <span
                data-v-5460a16b
                className={`s-rating-star-line s-bg-market-star-icon dark:s-bg-market-star-icon ${
                  animate ? "s-animate-star-line" : ""
                }`}
              />
              <span
                data-v-5460a16b
                className={`s-rating-star-line s-bg-market-star-icon dark:s-bg-market-star-icon ${
                  animate ? "s-animate-star-line" : ""
                }`}
              />
            </div>
          </div>
          <div data-v-089ef46b>
            <div
              data-v-089ef46b
              className="s-py-2px s-flex s-gap-3px s-justify-start s-items-center"
            >
              <div
                data-v-089ef46b
                className="s-flex s-justify-center s-items-center s-gap-2px"
              >
                {item?.status == "in_play" && (
                  <div>
                    <img
                      src={cdnImg("/assets/IconBetting/streaming.svg")}
                      alt="streaming"
                      className="s-h-14px"
                    />
                  </div>
                )}

                {item?.hasFancy && (
                  <div>
                    <img
                      src={cdnImg("/assets/IconBetting/fancybet.svg")}
                      alt="fancybet"
                      className="s-h-14px"
                    />
                  </div>
                )}
                {item?.hasBookmaker && (
                  <div>
                    <img
                      src={cdnImg("/assets/IconBetting/bookmaker.svg")}
                      alt="bookmaker"
                      className="s-h-14px"
                    />
                  </div>
                )}

                {item?.hasSportBook && (
                  <div>
                    <img
                      src={cdnImg("/assets/IconBetting/sportsbook.svg")}
                      alt="geniusSports"
                      className="s-h-14px"
                    />
                  </div>
                )}
              </div>
              {item?.status == "in_play" ? (
                <div
                  data-v-88ac4f64
                  className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                >
                  <div className="s-px-3px s-leading-14px s-flex s-items-center s-justify-center s-bg-inPlay-light dark:s-bg-inPlay-dark s-text-black s-flex-1">
                    <span className="s-text-12px s-leading-120 s-text-center">
                      In-play
                    </span>
                  </div>
                </div>
              ) : (
                <div
                  data-v-88ac4f64
                  className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                >
                  <div className="s-time-block s-flex s-items-center s-justify-center s-flex-1 s-bg-today-light dark:s-bg-today-dark">
                    <span className="s-text-12px s-leading-120 s-text-black s-text-center s-whitespace-nowrap s-px-3px s-py-0">
                      {isDateToday(item?.eventDateTime)
                        ? "Today"
                        : moment(item?.eventDateTime).format("DD/MM")}
                    </span>
                    <span className="s-text-12px s-leading-120 s-text-black s-text-center s-pr-3px">
                      {moment(item?.eventDateTime).format("HH:MM")}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div
              data-v-089ef46b
              className="s-flex s-justify-between s-items-center s-gap-10px"
            >
              <p
                data-v-089ef46b
                className="s-leading-140 s-text-17px s-font-bold s-text-global-font-default-light dark:s-text-global-font-default-dark s-truncate"
              >
                {/* {item?.eventName} */}
                {item?.eventName?.split(" v ")[0]}{" "}
                {!isEmpty(item?.outcome) ? (
                  <span
                    className="score_color d-flex justify-content-center align-items-center"
                    style={{
                      width: "25%",
                      color: "rgb(197 158 0)",
                    }}
                  >
                    {` ${item?.outcome} `}
                  </span>
                ) : (
                  <span
                    className="score_color d-flex justify-content-center align-items-center"
                    style={{
                      width: "25%",
                    }}
                  >
                    {" v "}
                  </span>
                )}
                {item?.eventName?.split(" v ")[1]}
              </p>
              <div data-v-089ef46b className="s-flex s-items-center s-gap-7px">
                {item?.hasOwnProperty("scoreId") &&
                  item.scoreId != null &&
                  item.scoreId !== 0 &&
                  item.scoreId !== "0" && (
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleScore(item?.scoreId);
                      }}
                      data-v-01c3d0b5
                      className={` s-text-16px  s-text-icon-dark dark:s-text-global-font-default-dark  s-text-[var(--color-market-name)] ${
                        showScore?.includes(item?.scoreId)
                          ? "s-icon-h2h-solid"
                          : "s-icon-h2h"
                      } `}
                    />
                  )}
              </div>
            </div>
          </div>
          <div data-v-089ef46b className="s-flex">
            <span
              data-v-089ef46b
              className="s-relative s-icon-arrow-down s-text-12px s-text-black-400 -s-rotate-90 dark:s-text-black-600"
            />
          </div>
        </div>
      </div>
    );
  };
  const isBeforeThreeHours = (object) => {
    const now = object?.eventDateTime;
    const threeHoursFromNow = moment(now).subtract(3, "hours").toDate();
    return moment(threeHoursFromNow).isAfter(moment().toDate());
  };
  const getBlockLimit = (object) => {
    return blockList?.length > 0
      ? blockList?.find((res) => {
          return res?.eventId == object?.eventId;
        })
      : {};
  };

  const getMatchLimit = (object) => {
    return matchLimit?.length > 0
      ? matchLimit?.find((res) => {
          return (
            res?.betfairId == object?.eventType && res?.market == "Match Odds"
          );
        })
      : {};
  };

  let limitCustomInplay = isEmpty(profileData?.limitCustomInplay)
    ? {
        cricket: 20000,
        soccer: 50000,
        tennis: 50000,
      }
    : profileData?.limitCustomInplay;

  return (
    <div className="s-mb-20px">
      {type == "all" && (
        <div className="s-bg-main-sport-bg s-h-35px s-flex s-items-center s-px-2 s-mb-12px">
          <i className="s-text-15px s-text-main-tab-text-active s-icon-cricket" />
          <div className="s-text-15px s-flex-1 s-text-main-tab-text-active s-font-bold s-leading-none">
            <span className="s-ml-5px">{startCase(heading)}</span>
          </div>
          <div
            onClick={() =>
              handle(lowerCase(heading), "", showAll == true ? false : true)
            }
            style={{ color: "black" }}
            className="s-sort-Filter s-inline-flex s-items-center s-justify-center s-bg-white s-text-11px s-cursor-pointer s-shadow-all-button s-bg-opacity-50 s-py-5px s-px-7px s-rounded-5px s-text-black-800 dark:s-text-black-300 dark:s-bg-opacity-20"
          >
            <span className="s-mr-1">Collapse</span>
            <i
              className={`s-icon-arrow-double s-mt-px s-transition-transform s-origin-center s-duration-300 s-transform ${
                showAll ? "s-rotate-180" : ""
              } `}
            />
          </div>
        </div>
      )}
      <div className="s-px-2">
        {data?.map((res) => {
          const showSeriesOdds =
            profileData?.seriesBlockList?.length > 0
              ? profileData?.seriesBlockList?.find(
                  (item) => item?.seriesId == res?.seriesId,
                )?.matchOdds == "on" || true
              : true;
          return (
            <div className="s-mb-12px">
              <div
                onClick={() => handle(res?.gameType, res?.seriesId)}
                className="s-relative s-flex s-items-center s-min-h-38px s-py-2 s-px-10px s-rounded-5px s-cursor-pointer s-transition-all s-duration-300 s-bg-main-collapse s-text-event-tab s-rounded-t-5px s-rounded-b-none"
              >
                <h1 className="s-w-full s-flex s-items-center s-text-14px s-text-event-tab s-font-normal s-leading-20px">
                  <span className="s-text-16px s-leading-120 s-break-words">
                    {res?.seriesName}
                  </span>
                  <span
                    style={{
                      color: "rgb(255, 184, 12)",
                      borderColor: "rgb(255, 184, 12)",
                    }}
                    className="s-w-24px s-h-20px s-leading-16px s-flex s-justify-center s-items-center s-text-center s-text-12px s-font-semibold s-rounded-3px s-flex-shrink-0 s-ml-auto s-mr-10px s-border s-border-solid s-border-event-tab s-text-event-tab"
                  >
                    {res?.matchList?.length}
                  </span>
                  <span
                    style={{ color: "rgb(255, 184, 12)" }}
                    className={`${
                      active?.includes(res?.seriesId) ? "s-rotate-180" : ""
                    } s-icon-arrow-down-sencodary s-flex s-items-center s-text-12px s-transition-transform s-origin-center s-duration-300 s-text-event-tab s-transform`}
                  />
                </h1>
              </div>
              {active?.includes(res?.seriesId) &&
                res?.matchList?.map((item, index) => {
                  let matchOdds = !parlay
                    ? odds?.find((ob) => {
                        return ob?.mi == item?.marketId;
                      }) || {}
                    : [];

                  let limitBlock = getBlockLimit(item);

                  let show =
                    item?.runners?.length > 0 &&
                    item?.hasMatchOdds &&
                    showSeriesOdds &&
                    (!isEmpty(limitBlock)
                      ? limitBlock?.matchOdds == "on"
                      : true) &&
                    (item?.status == "in_play"
                      ? matchOdds?.totalMatched >
                        limitCustomInplay[item?.gameType]
                      : item?.gameType == "cricket"
                        ? matchOdds?.totalMatched > 100000
                        : false) &&
                    !isEmpty(matchOdds) &&
                    !parlay &&
                    (!isEmpty(profileData) && profileData?.minMatchingAmount > 0
                      ? matchOdds?.totalMatched > profileData?.minMatchingAmount
                      : true);

                  let animate = activeFav?.includes(item?.eventId);
                  let scoreDisplay =
                    scoreAll?.length > 0
                      ? scoreAll?.find((obj) => {
                          return obj?.eventId == item?.eventId;
                        })
                      : {};

                  let limitList = getMatchLimit(item);
                  let outerCondition =
                    isBeforeThreeHours(item) ||
                    matchOdds?.ms != 1 ||
                    (!isEmpty(limitList) &&
                      matchOdds?.totalMatched < limitList?.limit);
                  return (
                    <div className="s-overflow-hidden">
                      {parlay && item?.eventName != "Indian Premier League" ? (
                        <ListParlay
                          index={index}
                          handleScore={handleScore}
                          showScore={showScore}
                          object={item}
                          odds={odds}
                        />
                      ) : (
                        <div className="s-shadow-2sm">
                          {show ? (
                            <div
                              onClick={() =>
                                navigate(
                                  `/match-detail/${item?.eventId}/${item?.marketId}`,
                                )
                              }
                              data-v-1483f0a5
                              className="s-bg-white dark:s-bg-main-block-dark s-rounded-5px"
                            >
                              <div
                                style={
                                  theme == "light"
                                    ? {
                                        background: "white",
                                        border: "none",
                                        color: "black",
                                      }
                                    : {
                                        background: "#043b3d",
                                        border: "1px solid #064b4d",
                                        color: "white",
                                      }
                                }
                                data-v-1483f0a5
                                className={`${
                                  isMobile
                                    ? "isDefaultMobile"
                                    : "isDefaultDesktop"
                                }  s-event-grid s-grid s-justify-center s-items-center s-gap-10px s-py-11px s-px-10px s-bg-primary`}
                              >
                                <div
                                  onClick={(e) => {
                                    if (item?.runners?.length > 0) {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      addToFavioute(
                                        item?.eventId,
                                        "Match Odds",
                                        item?.marketId,
                                        item?.eventType,
                                      );
                                    }
                                  }}
                                  data-v-5460a16b
                                  data-v-1483f0a5
                                  className="s-fav s-text-market-star-icon dark:s-text-market-star-icon s-text-16px s-w-16px"
                                >
                                  <div
                                    data-v-5460a16b
                                    className={`s-relative s-icon-star${
                                      animate
                                        ? "-solid s-animate-star-line-box"
                                        : ""
                                    }`}
                                  >
                                    <span
                                      data-v-5460a16b
                                      className={`s-rating-star-line s-bg-market-star-icon dark:s-bg-market-star-icon ${
                                        animate ? "s-animate-star-line" : ""
                                      }`}
                                    />
                                    <span
                                      data-v-5460a16b
                                      className={`s-rating-star-line s-bg-market-star-icon dark:s-bg-market-star-icon ${
                                        animate ? "s-animate-star-line" : ""
                                      }`}
                                    />
                                    <span
                                      data-v-5460a16b
                                      className={`s-rating-star-line s-bg-market-star-icon dark:s-bg-market-star-icon ${
                                        animate ? "s-animate-star-line" : ""
                                      }`}
                                    />
                                  </div>
                                </div>
                                <div
                                  data-v-1483f0a5
                                  className="s-flex s-justify-between s-items-center s-gap-10px"
                                >
                                  <p
                                    style={
                                      theme == "light"
                                        ? { color: "black" }
                                        : { color: "white" }
                                    }
                                    data-v-1483f0a5
                                    className="s-text-17px s-font-bold s-leading-120 s-text-market-name s-truncate"
                                  >
                                    {item?.eventName?.split(" v ")[0]}{" "}
                                    {!isEmpty(item?.outcome) ? (
                                      <span
                                        className="score_color d-flex justify-content-center align-items-center"
                                        style={{
                                          width: "25%",
                                          color: "rgb(197 158 0)",
                                        }}
                                      >
                                        {` ${item?.outcome} `}
                                      </span>
                                    ) : (
                                      <span
                                        className="score_color d-flex justify-content-center align-items-center"
                                        style={{
                                          width: "25%",
                                        }}
                                      >
                                        {" v "}
                                      </span>
                                    )}
                                    {item?.eventName?.split(" v ")[1]}
                                  </p>
                                  <div
                                    data-v-1483f0a5
                                    className="s-flex s-items-center s-gap-7px"
                                  >
                                    {!isEmpty(scoreDisplay) && (
                                      <div
                                        data-v-1483f0a5
                                        className="s-text-16px s-font-bold s-whitespace-nowrap s-text-market-name"
                                      >
                                        <span>{scoreDisplay?.score}</span>
                                      </div>
                                    )}

                                    {item?.hasOwnProperty("scoreId") &&
                                      item.scoreId != null &&
                                      item.scoreId !== 0 &&
                                      item.scoreId !== "0" && (
                                        <span
                                          style={{
                                            color:
                                              theme == "dark"
                                                ? "#ffb80c"
                                                : "black",
                                          }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleScore(item?.scoreId);
                                          }}
                                          data-v-01c3d0b5
                                          className={` s-text-16px ${
                                            showScore?.includes(item?.scoreId)
                                              ? "s-icon-h2h-solid"
                                              : "s-icon-h2h"
                                          } `}
                                        />
                                      )}
                                  </div>
                                </div>
                                <div data-v-1483f0a5 className="s-flex">
                                  <span
                                    style={
                                      theme == "light"
                                        ? { color: "black" }
                                        : { color: "#ffb80c" }
                                    }
                                    data-v-1483f0a5
                                    className="s-relative s-icon-arrow-down s-text-12px s-text-market-name -s-rotate-90"
                                  />
                                </div>
                              </div>

                              <div data-v-1483f0a5 className="s-p-3px s-pt-0">
                                <div className="s-flex s-justify-between s-items-center">
                                  <div className="s-py-4px s-flex s-gap-3px s-justify-start s-items-center">
                                    <div
                                      data-v-88ac4f64
                                      className="s-flex s-justify-center s-items-center s-gap-2px"
                                    >
                                      {item?.status == "in_play" && (
                                        <div>
                                          <img
                                            src={cdnImg(
                                              "/assets/IconBetting/streaming.svg",
                                            )}
                                            alt="streaming"
                                            className="s-h-14px"
                                          />
                                        </div>
                                      )}

                                      {item?.hasFancy && (
                                        <div>
                                          <img
                                            src={cdnImg(
                                              "/assets/IconBetting/fancybet.svg",
                                            )}
                                            alt="fancybet"
                                            className="s-h-14px"
                                          />
                                        </div>
                                      )}
                                      {item?.hasBookmaker && (
                                        <div>
                                          <img
                                            src={cdnImg(
                                              "/assets/IconBetting/bookmaker.svg",
                                            )}
                                            alt="bookmaker"
                                            className="s-h-14px"
                                          />
                                        </div>
                                      )}

                                      {item?.hasSportBook && (
                                        <div>
                                          <img
                                            src={cdnImg(
                                              "/assets/IconBetting/sportsbook.svg",
                                            )}
                                            alt="geniusSports"
                                            className="s-h-14px"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {item?.status == "in_play" ? (
                                      <div
                                        data-v-88ac4f64
                                        className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                                      >
                                        <div className="s-px-3px s-leading-14px s-flex s-items-center s-justify-center s-bg-inPlay-light dark:s-bg-inPlay-dark s-text-black s-flex-1">
                                          <span className="s-text-12px s-leading-120 s-text-center">
                                            In-play
                                          </span>
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        data-v-88ac4f64
                                        className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                                      >
                                        <div className="s-time-block s-flex s-items-center s-justify-center s-flex-1 s-bg-today-light dark:s-bg-today-dark">
                                          <span className="s-text-12px s-leading-120 s-text-black s-text-center s-whitespace-nowrap s-px-3px s-py-0">
                                            {isDateToday(item?.eventDateTime)
                                              ? "Today"
                                              : moment(
                                                  item?.eventDateTime,
                                                ).format("DD/MM")}
                                          </span>
                                          <span className="s-text-12px s-leading-120 s-text-black s-text-center s-pr-3px">
                                            {moment(item?.eventDateTime).format(
                                              "HH:MM",
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    {item?.totalMatched > 0 && (
                                      <p
                                        style={
                                          theme == "light"
                                            ? {
                                                color: "white",
                                                fontWeight: "600",
                                              }
                                            : {
                                                color: "white",
                                                fontWeight: "600",
                                              }
                                        }
                                        data-v-88ac4f64
                                        className="s-text-12px s-leading-120 s-text-black-600"
                                      >
                                        {" "}
                                        Matched{" "}
                                        <span data-v-88ac4f64>
                                          {formatWithCommas(item?.totalMatched)}
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                  {show && (
                                    <div className="s-w-129px s-py-1px s-flex s-gap-1px s-text-14px s-font-bold s-leading-140 s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark">
                                      <div className="s-w-64px">Back</div>
                                      <div className="s-w-64px">Lay</div>
                                    </div>
                                  )}
                                </div>
                                {show && (
                                  <HomeSelection
                                    matchOdds={matchOdds}
                                    object={item}
                                    outerCondition={outerCondition}
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            <RenderSingle item={item} animate={animate} />
                          )}
                        </div>
                      )}

                      {showScore?.includes(item?.scoreId) && (
                        <div
                          style={{ position: "relative" }}
                          className="s-bg-black-300 dark:s-bg-white dark:s-bg-opacity-5 s-p-7px s-border-t s-border-black-400 dark:s-border-black-900"
                        >
                          <RxCross2
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleScore(item?.scoreId);
                            }}
                            size={17}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "10px",
                            }}
                          />
                          {displayScore({ object: item })}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListingSportComp;
